import { MxMask } from './mx-mask';

export class MxBaseMask {
	parseAttributes = [];

	link(scope, elem, attrs, ngModel, locale, $parse, i18n) {
		const that = this;
		that.element = elem;
		that.format = attrs.mxMaskFormat;
		that.localeFormats = locale.NUMBER_FORMATS;
		that.i18n = i18n;

		const formatter = that.createFormatter(ngModel);
		const parser = that.createParser(ngModel);

		if (formatter) {
			ngModel.$formatters.push(function (value) {
				if (ngModel.$isEmpty(value)) {
					return value;
				}

				return formatter.call(that, value);
			});
		}
		if (parser) {
			ngModel.$parsers.push(function (value) {
				if (ngModel.$isEmpty(value)) {
					return value;
				}
				return parser.call(that, value);
			});
		}

		this.parseAttributes.forEach(function (item) {
			if (attrs[item]) {
				that[item] = attrs[item].indexOf(':') === -1 ? $parse(attrs[item])(scope) : attrs[item];
			}
		});

		this.callbacks = {
			onChange: function (value) {
				return ngModel.$setViewValue(value);
			},
		};

		if (this.focus) {
			elem.on('focus', function () {
				that.focus(ngModel);
			});
		}

		if (this.blur) {
			elem.on('blur', function () {
				that.blur(ngModel);
			});
		}

		this.initialize(this.callbacks);
	}

	createParser() {
		throw new Error('Mask. createParser method is not implemented');
	}
	createFormatter() {
		throw new Error('Mask. createFormatter method is not implemented');
	}

	initialize() {}

	createMask(pattern, options) {
		return new MxMask($(this.element).find('input')[0] || this.element, pattern, options);
	}

	repeat(str, times) {
		return new Array(times + 1).join(str);
	}
}
